module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video7.4e40cd23.mp4";